

const Navbar = () => {
  return (

    <div className="navbar">
        <h1>React Weather App</h1>
        <div className="links-container">
            <a href="https://www.linkedin.com/in/adrian-centurion/" target={"_blank"}><img className="icons linkedin"  src={require("../../img/linkedin-brands.svg").default}></img></a>
            <a href="https://github.com/adrianmcenturion/react-weather-app" target={"_blank"}><img className="icons github"  src={require("../../img/github-brands.svg").default}></img></a>
        </div>

    </div>




    
  )
}

export default Navbar